import React from "react";
import Toggle from '../Toggle/Toggle'
import './Navbar.css'
import { useContext } from "react";
import { themeContext } from "../../Context";
import {Link} from 'react-scroll'
const Navbar = ()=>{

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    return(
        
         <div style={{color: darkMode? 'white': ''}} className="n-wrapper">
                 <div className="n-left">
                     <div className="n-name">Andrew</div>
                    <Toggle/>
                 </div>
                 
                 <div className="n-right">
                        <div className="n-list">
                            <ul>
                                <Link spy={true} to='Navbar' smooth={true} activeClass="activeClass">
                                       <li>Home</li>
                                </Link>

                                <Link spy={true} to='Services' smooth={true}>
                                <li>Services</li>
                                </Link>

                                <Link spy={true} to='Experience' smooth={true}>
                                <li>Experience</li>
                                </Link>

                                <Link spy={true} to='Portfolio' smooth={true}>
                                <li>Portfolio</li>
                                </Link>

                                <Link spy={true} to='Testimonials' smooth={true}>
                                <li>Testimonials</li>
                                </Link>
                            </ul>
                        </div>
                        <button className="button n-button">
                            Contact us
                        </button>
                 </div>
         </div>
    )
};

export default Navbar;